"use client"

import { useEffect } from 'react'

export function ErrorBoundary({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // 处理未捕获的Promise错误
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      const errorMessage = event.reason?.message || ''
      const errorStack = event.reason?.stack || ''
      
      // 静默处理已知的无害错误（通常来自浏览器扩展）
      const knownExtensionErrors = [
        'message channel closed',
        'A listener indicated an asynchronous response',
        'Extension context invalidated',
        'Could not establish connection',
        'The message port closed before a response was received',
        'chrome-extension://',
        'moz-extension://'
      ]
      
      const isExtensionError = knownExtensionErrors.some(pattern => 
        errorMessage.includes(pattern) || errorStack.includes(pattern)
      )
      
      if (isExtensionError) {
        event.preventDefault()
        // 只在开发环境显示这些警告
        if (process.env.NODE_ENV === 'development') {
          console.warn('🔌 Browser extension error (handled):', errorMessage)
        }
        return
      }
      
      // 其他错误正常处理
      console.error('❌ Unhandled promise rejection:', event.reason)
    }

    // 处理一般的JavaScript错误
    const handleError = (event: ErrorEvent) => {
      const errorMessage = event.message || ''
      const errorFilename = event.filename || ''
      
      // 静默处理已知的无害错误
      const knownExtensionErrors = [
        'message channel closed',
        'Extension context invalidated',
        'chrome-extension://',
        'moz-extension://'
      ]
      
      const isExtensionError = knownExtensionErrors.some(pattern => 
        errorMessage.includes(pattern) || errorFilename.includes(pattern)
      )
      
      if (isExtensionError) {
        event.preventDefault()
        // 只在开发环境显示这些警告
        if (process.env.NODE_ENV === 'development') {
          console.warn('🔌 Browser extension error (handled):', errorMessage)
        }
        return
      }
      
      // 其他错误正常处理
      console.error('❌ JavaScript error:', event.error || event.message)
    }

    // 添加事件监听器
    window.addEventListener('unhandledrejection', handleUnhandledRejection)
    window.addEventListener('error', handleError)

    // 清理函数
    return () => {
      window.removeEventListener('unhandledrejection', handleUnhandledRejection)
      window.removeEventListener('error', handleError)
    }
  }, [])

  return <>{children}</>
} 